var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginSignupLeftVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 494,
    viewBox: "0 0 515 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_961_596",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 515,
    height: 494
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 515,
    height: 494,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_961_596)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.5 494C375.537 494 515 354.537 515 182.5C515 10.4633 375.537 -129 203.5 -129C31.4633 -129 -108 10.4633 -108 182.5C-108 354.537 31.4633 494 203.5 494ZM198.396 400.391C173.77 399.462 163.639 371.371 178.014 351.355L238.66 266.914C277.608 212.682 277.005 139.486 237.167 85.9035L185.399 16.2734C170.224 -4.13662 180.918 -33.1501 206.351 -33.161C221.383 -33.1675 236.422 -31.5864 251.221 -28.4132C283.481 -21.4957 313.73 -7.197 339.634 13.3784C365.537 33.9537 386.4 60.2549 400.612 90.2501C414.824 120.245 422.003 153.132 421.596 186.368C421.189 219.605 413.205 252.303 398.263 281.935C383.321 311.568 361.82 337.342 335.42 357.266C309.021 377.191 278.43 390.732 246.01 396.845C230.267 399.813 214.297 400.991 198.396 400.391Z",
    fill: "#EEF4F8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSignupLeftVector);
export default __webpack_public_path__ + "static/media/login_signup_left_vector.64755edf8b18d07259f4909d76000acf.svg";
export { ForwardRef as ReactComponent };